import React, { useState, useEffect} from 'react'
import axios from '../../api/api'
import { useParams } from 'react-router-dom'
import { FaUser } from 'react-icons/fa';
import CustomerDetails from './CustomerDetails'
import CustomerCommission from './CustomerCommission'
import CustomerSuccessful from './CustomerSuccessful'
import CustomerFailed from './CustomerFailed'

const ViewCustomer = () => {

  const { id } = useParams()
  const [viewCustomer, setViewCustomer] = useState([])

  // getting customer by id
  useEffect(() => {
    const getCustomer = async () => {
      try {
        const response = await axios.get(`/customer/${id}/details`)
        setViewCustomer(response.data)
      } catch (error) {
        console.log(error)
      }
    }
    getCustomer()
  },[id])

  return (
    <div className='mx-auto p-4'>
      <div className="bg-white rounded-lg p-4">
        <h4><b>Customer Details</b></h4>
        <div className='my-4 flex items-center space-x-4'>
          <h1 className='text-[#2b1e3e]'><FaUser /></h1>
          <div>
            <h5>{viewCustomer.msisdn}</h5>
            <p>
              {viewCustomer.user_type === 1 ? (
                <span>Customer</span>
              ) : viewCustomer.user_type === 2 ? (
                <span>Agent</span>
              ) : (
                <span>Dealer</span>
              )}
            </p>
          </div>
        </div>
      </div>

      {/* tabs */}
      <div role="tablist" className="tabs tabs-bordered overflow-x-auto mt-2 ">
        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Customer Details" defaultChecked />
        <div role="tabpanel" className="tab-content py-4 overflow-hidden">
          <CustomerDetails />
        </div>

        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Commission Statement" />
        <div role="tabpanel" className="tab-content py-4">
          <CustomerCommission />
        </div>

        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Successful Requests" />
        <div role="tabpanel" className="tab-content py-4">
          <CustomerSuccessful msisdn={viewCustomer.msisdn} />
        </div>

        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Failed Requests" />
        <div role="tabpanel" className="tab-content py-4">
          <CustomerFailed number={viewCustomer.msisdn} />
        </div>
      </div>
    </div>
  )
}

export default ViewCustomer
